import BaseModelFactory from './base.factory'
import TermLengthsService from '../services/TermLengths.service'
import TermLengths from '../models/term-length.model'

class TermLengthsFactory extends BaseModelFactory {
  static search = async ({ search, pagination, order_by, method }) =>
    await this._search({ search, pagination, order_by, method }, { Service: TermLengthsService, Model: TermLengths })
  static findById = async id => await this._findBy({ id: id }, { Service: TermLengthsService, Model: TermLengths })
  static findAllById = async id =>
    await this._findAllBy({ id: id }, { Service: TermLengthsService, Model: TermLengths })
  static findByUsertypeId = async usertypeId =>
    await this._findBy({ usertype_id: usertypeId }, { Service: TermLengthsService, Model: TermLengths })
  static create = payload =>
    this._create(payload, {
      Service: TermLengthsService,
      Model: TermLengths,
    })
}

export default TermLengthsFactory
